<template>
  <router-view></router-view>
</template>

<script>

export default {
    
    data () {
    return {
    }
  },
  localStorage: {
    user: {
      type: Object,
      default: {
        authenticated: false,
        id: 0,
        name: '',
        email: '',
        picture: '',
        language: '',
        timezone: ''
      }
    },
    synchronized: {
      type: Number,
      default: 0
    },
    token: {
      type: Object,
      default: {
        id: 0,
        pk: ''
      }
    },
    alwaysSync: {
      type: Boolean,
      default: true
    },
    iosTryInstall: {
      type: Boolean,
      default: true
    }
  }
};
</script>
<style scoped>
</style>